import { Clear as ClearIcon, Search as SearchIcon } from "@mui/icons-material";
import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import * as labels from "config.labels";
import React from "react";
import { useState } from "react";
import * as staticDataHooks from "store/hooks/staticDataHooks";

const ClearableSearchField = ({
  value,
  onChange,
  placeholder = "Search",
  sx,
  countDisplay,
  disabled = false,
}) => {
  const translateLabels = staticDataHooks.useTranslator("uiLabels");
  const [isFocused, setIsFocused] = useState(false);
  const handleClear = () => {
    onChange("");
  };
  return (
    <TextField
      size={"small"}
      label={isFocused || value.length > 0 ? placeholder : `${placeholder}…`}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      onKeyDown={(e) => {
        if (e.key === "Escape") {
          handleClear();
        }
      }}
      disabled={disabled}
      sx={{
        width: "100%",
        maxWidth: 300,
        minWidth: "6.5em",
        ...sx,
      }}
      slotProps={{
        inputLabel: {
          shrink: value.length > 0 || isFocused,
          sx: {
            textTransform: "capitalize",
            maxWidth: "calc(100% - 40px)",
            overflowX: "hidden",
            overflowY: "visible",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            ...(!value.length &&
              !isFocused && {
                transform: "translate(36px, 9px) scale(1)",
              }),
          },
        },
        input: {
          startAdornment: (
            <InputAdornment position={"start"}>
              <SearchIcon fontSize={"small"} color={"action"} />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position={"end"}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                {countDisplay && (
                  <Typography
                    variant={"caption"}
                    sx={{
                      color: "text.disabled",
                      fontSize: "0.7rem",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {value && `${countDisplay.filtered}/${countDisplay.total}`}
                  </Typography>
                )}
                {value && (
                  <Tooltip
                    title={translateLabels(
                      labels.CLEARABLE_SEARCH_FIELD_CLEAR_TOOLTIP,
                      { default: "Clear (ESC)" }
                    )}
                  >
                    <IconButton
                      size={"small"}
                      onClick={handleClear}
                      edge={"end"}
                    >
                      <ClearIcon fontSize={"small"} />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            </InputAdornment>
          ),
          sx: {
            "& input": {
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
          },
        },
      }}
    />
  );
};
export default ClearableSearchField;
